export const isFieldMissing = (field) => {
  if (field === null || field === undefined) return true;
  if (typeof field === "string") return field.trim() === "";
  return false;
};

export const isDobInvalid = (dob) => {
  if (isFieldMissing(dob)) return true;
  const normalized = String(dob).trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return true;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime());
};

export const PROFILE_PAYMENT_FIELDS = [
  {
    label: "name",
    formKey: "name",
    getValue: (profile) => profile?.name,
  },
  {
    label: "mobile number",
    formKey: "mobile",
    getValue: (profile) => profile?.mobile,
  },
  {
    label: "email",
    formKey: "email",
    getValue: (profile) => profile?.email,
    isInvalid: (email) =>
      isFieldMissing(email) ||
      !/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(String(email).trim()),
  },
  {
    label: "date of birth",
    formKey: "dob",
    getValue: (profile) => profile?.dob,
    isInvalid: isDobInvalid,
  },
  {
    label: "gender",
    formKey: "gender",
    getValue: (profile) => profile?.gender,
  },
  {
    label: "state",
    formKey: "state",
    getValue: (profile) => profile?.address?.state,
  },
  {
    label: "city",
    formKey: "city",
    getValue: (profile) => profile?.address?.city,
  },
];

export const getMissingProfileFieldLabels = (profile) =>
  PROFILE_PAYMENT_FIELDS.filter(({ getValue, isInvalid }) => {
    const value = getValue(profile);
    if (isInvalid) return isInvalid(value);
    return isFieldMissing(value);
  }).map((field) => field.label);

export const API_ERROR_FIELD_PATTERNS = [
  { pattern: /dob|date of birth/i, label: "date of birth" },
  { pattern: /gender/i, label: "gender" },
  { pattern: /state/i, label: "state" },
  { pattern: /city/i, label: "city" },
  { pattern: /name/i, label: "name" },
  { pattern: /mobile/i, label: "mobile number" },
  { pattern: /email/i, label: "email" },
];

export const inferMissingFieldsFromApiError = (message, currentFields = []) => {
  const inferred = [...currentFields];
  const lowerMessage = String(message || "").toLowerCase();

  API_ERROR_FIELD_PATTERNS.forEach(({ pattern, label }) => {
    if (pattern.test(lowerMessage) && !inferred.includes(label)) {
      inferred.push(label);
    }
  });

  return inferred;
};

export const getProfileFieldByLabel = (label) =>
  PROFILE_PAYMENT_FIELDS.find((field) => field.label === label);
